(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var getAssociatedArtists = require('./get-associated-artists')

module.exports = function (cb) {
  fetchArtists(function (artists) {
    setAssociatedArtists(artists)
    if (cb) return cb(getAssociatedArtists())
  })
}

function fetchArtists (cb) {
  Backbone.ajax(
    { url: window.config.apiUrl + '/administrators/' + getCurrentAdminId()
    , type: 'GET'
    , success: function (data) {
        return cb(data._artists)
      }
    , error: function () {
        if (console) {
          console.log('Failed to load associated artists')
        }
        cb([])
      }
    , dataType: 'json'
    , contentType: 'application/json'
    }
  )
}

function getCurrentAdminId () {
  return window.localStorage.getItem('apiId')
}

function setAssociatedArtists (artists) {
  console.log('artists', artists)
  for (var i = 0; i < artists.length; i++) {
    // remove the generalProvisions field
    delete artists[i].generalProvisions
  }

  window.localStorage.setItem('associatedArtists', JSON.stringify(artists))
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/reload-artists.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL3JlbG9hZC1hcnRpc3RzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbInZhciBnZXRBc3NvY2lhdGVkQXJ0aXN0cyA9IHJlcXVpcmUoJy4vZ2V0LWFzc29jaWF0ZWQtYXJ0aXN0cycpXG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKGNiKSB7XG4gIGZldGNoQXJ0aXN0cyhmdW5jdGlvbiAoYXJ0aXN0cykge1xuICAgIHNldEFzc29jaWF0ZWRBcnRpc3RzKGFydGlzdHMpXG4gICAgaWYgKGNiKSByZXR1cm4gY2IoZ2V0QXNzb2NpYXRlZEFydGlzdHMoKSlcbiAgfSlcbn1cblxuZnVuY3Rpb24gZmV0Y2hBcnRpc3RzIChjYikge1xuICBCYWNrYm9uZS5hamF4KFxuICAgIHsgdXJsOiB3aW5kb3cuY29uZmlnLmFwaVVybCArICcvYWRtaW5pc3RyYXRvcnMvJyArIGdldEN1cnJlbnRBZG1pbklkKClcbiAgICAsIHR5cGU6ICdHRVQnXG4gICAgLCBzdWNjZXNzOiBmdW5jdGlvbiAoZGF0YSkge1xuICAgICAgICByZXR1cm4gY2IoZGF0YS5fYXJ0aXN0cylcbiAgICAgIH1cbiAgICAsIGVycm9yOiBmdW5jdGlvbiAoKSB7XG4gICAgICAgIGlmIChjb25zb2xlKSB7XG4gICAgICAgICAgY29uc29sZS5sb2coJ0ZhaWxlZCB0byBsb2FkIGFzc29jaWF0ZWQgYXJ0aXN0cycpXG4gICAgICAgIH1cbiAgICAgICAgY2IoW10pXG4gICAgICB9XG4gICAgLCBkYXRhVHlwZTogJ2pzb24nXG4gICAgLCBjb250ZW50VHlwZTogJ2FwcGxpY2F0aW9uL2pzb24nXG4gICAgfVxuICApXG59XG5cbmZ1bmN0aW9uIGdldEN1cnJlbnRBZG1pbklkICgpIHtcbiAgcmV0dXJuIHdpbmRvdy5sb2NhbFN0b3JhZ2UuZ2V0SXRlbSgnYXBpSWQnKVxufVxuXG5mdW5jdGlvbiBzZXRBc3NvY2lhdGVkQXJ0aXN0cyAoYXJ0aXN0cykge1xuICBjb25zb2xlLmxvZygnYXJ0aXN0cycsIGFydGlzdHMpXG4gIGZvciAodmFyIGkgPSAwOyBpIDwgYXJ0aXN0cy5sZW5ndGg7IGkrKykge1xuICAgIC8vIHJlbW92ZSB0aGUgZ2VuZXJhbFByb3Zpc2lvbnMgZmllbGRcbiAgICBkZWxldGUgYXJ0aXN0c1tpXS5nZW5lcmFsUHJvdmlzaW9uc1xuICB9XG5cbiAgd2luZG93LmxvY2FsU3RvcmFnZS5zZXRJdGVtKCdhc3NvY2lhdGVkQXJ0aXN0cycsIEpTT04uc3RyaW5naWZ5KGFydGlzdHMpKVxufVxuIl19